<template>
    <div class="project-single-page body-box">
        <div class="project-single-body">
            <div class="project-single-body-inner">
                <div class="project-single-infos">
                    <div class="project-single-info-item">
                        <span class="title">Client</span>
                        : Goven Soven
                    </div>
                    <div class="project-single-info-item">
                        <span class="title">Company</span>
                        : Seven Studio
                    </div>
                    <div class="project-single-info-item">
                        <span class="title">Project Type</span>
                        : Product design, Icon design
                    </div>
                    <div class="project-single-info-item">
                        <span class="title">Year</span>
                        : 2023
                    </div>
                </div>

                <div class="project-single-title-description">
                    <img :src="require('@/assets/images/project1.jpg')" alt="Project Single" />
                    <h2>Seven Studio</h2>
                    <p>An innovative platform that empowers businesses to efficiently manage their workforce, delivering a seamless user experience while distinguishing itself from competitors.</p>
                    <a href="https://google.com" class="theme-btn">
                        <span class="btn-shape"></span>
                        <span class="btn-shape"></span>
                        <span class="btn-shape"></span>
                        Visit Website
                        <i class="las la-arrow-right arrow-right"></i>
                    </a>
                </div>

                <div class="project-single-contents">
                    <img :src="require('@/assets/images/project-single.jpg')" alt="Project" />
                    <p class="mt-20">A business owner enlisted my expertise as a product designer to develop a website that would boost their brand awareness and conversions. Crafting a modern, professional website, my priority was to set them apart from competitors and attract new customers.</p>
                    <img class="mt-32" :src="require('@/assets/images/project-single-2.jpg')" alt="Project" />
                    <h2 class="mt-40">The Problems to Solve</h2>
                    <p class="mt-20">To tackle this endeavor, our approach revolved around shaping a unique brand identity that adeptly conveyed Rectangle's fundamental principles of sustainability, innovation, and authenticity. Our team devoted meticulous attention to crafting an all-encompassing brand strategy, encompassing both product design and website development, geared towards establishing a visually captivating and unforgettable brand persona, distinguishing Rectangle amidst its competition.</p>
                    <img class="mt-32" :src="require('@/assets/images/project-single-3.jpg')" alt="Project" />
                    <div class="project-single-our-solution">
                        <h2 class="mt-40">Our Solution</h2>
                        <p class="mt-20">Through thoughtful product design, we ensured that Rectangle's offerings seamlessly aligned with their core values, incorporating sustainable materials and innovative design principles. Concurrently, our website development team crafted a user-centric digital platform that not only showcased Rectangle's products but also effectively conveyed their environmental mission, fostering authentic engagement with visitors.</p>
                    </div>

                </div>

            </div>

            <projects-section headerTitle="Other Projects" />

            <news-letter />

            <ohilo-footer />
        </div>

    </div>
</template>

<script>
import ProjectsSection from '@/components/sections/ProjectsSection.vue';
import NewsLetter from '@/components/sections/NewsLetter.vue';
import OhiloFooter from '@/components/common/OhiloFooter.vue';

export default {
    name: 'ProjectSingleView',
    components: {
        ProjectsSection,
        NewsLetter,
        OhiloFooter,
    }
    
}
</script>